import { debounce } from 'lodash-es';
import { useDefaultModal } from '../defaultModal';
import Upload, { type IProps } from './upload.vue';

export const useAvatarUpload = debounce((options: Omit<IProps, 'cancel'> & { title: string }) => {
  const { title, ...rest } = options;

  const cancel = () => {
    modal.destroy();
  };
  const modal = useDefaultModal({
    closable: true,
    center: true,
    footer: false,
    title,
    width: 420,
    content: <Upload cancel={cancel} {...rest} />,
  });
}, 200);
